import React, { use, useEffect, useRef, useState } from "react";
import Pusher from "react-pusher";
import "./event-listing.scss";
import CountdownTimer from "../../components/CountdownTimer";
import Events from "../../components/Events/Events";
import { useDispatch, useSelector } from "react-redux";
import Attendees from "../../components/Events/Attendees";
import MeetingTable from "../../components/meeting-table/MeetingTable";
import { toast } from "react-toastify";
import { SiJitsi } from "react-icons/si";

// images
import AppleStore from "../../images/apple-store.png";
import GooglePlayStore from "../../images/google-playstore.png";
import MainContainer from "../../components/main-container/main-container.component";
import axios from "axios";
import clientConfig from "../../env";
import { updateBetaCredit } from "../../redux/user/user.actions";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "../../components/modal/modal.components";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { IoSearchSharp } from "react-icons/io5";
import moment from "moment";
import { CiCalendar, CiClock2 } from "react-icons/ci";
import useCheckMobileScreen from "../../components/useCheckMobileView";
import CustomTooltip from "../../components/toolTips/tooltips.components";
import { filterEventsByTimezone, isEventJoinable } from "../../utilities/eventFiltering";

const initialEventData = {
  event_name: "",
  topic_description: "",
  event_date: "",
  event_time: "",
  event_type: "public",
  event_invites: "",
};

function EventListing() {
  const meetingTableRef = useRef(null);
  const joinTableConfirmationRef = useRef(null);
  const joinTableConfirmationClosebtnRef = useRef(null);

  const dispatch = useDispatch();

  const history = useHistory();
  const mobileScreen = useCheckMobileScreen();

  const token = useSelector((state) => state.user.token);
  const userCredit = useSelector((state) => state.user.mycredits);
  const userId = useSelector((state) => state.user.userId);
  const firstName = useSelector((state) => state.user.firstName);
  const profile_picture = useSelector((state) => state.user.profile_picture);
  const userEmail = useSelector((state) => state.user.email);
  const email_verified = useSelector((state) => state.user.email_verified);
  const currentEventDetail = useSelector(
    (state) => state.events.currentEventDetail,
  );
  const isMasterTableEnable = useSelector(
    (state) => state.events.masterTableEnable,
  );

  const isAllTableDisable = useSelector(
    (state) => state.events.allTableDisable,
  );

  const [tableList, setTableList] = useState([]);
  const [eventTableUsers, setEventTableUsers] = useState([]);
  const [isLoadingTableList, setLoadingTableList] = useState(true);
  const [popupVisible, setPopupVisible] = useState(false);

  const [popupJoinTableNumber, setPopupJoinTableNumber] = useState(null);
  const [openCreateEvent, setOpenCreateEvent] = useState(false);
  const [eventData, setEventData] = useState(initialEventData);

  const [pastEvents, setPastEvents] = useState([]);
  const [personalEvents, setPersonalEvents] = useState([]);
  const [paginatedPersonalEvents, setPaginatedPersonalEvents] = useState([]);
  const [currentPersonalPage, setCurrentPersonalPage] = useState(1);

  const [readOnlyData, setReadOnlyData] = useState(false);
  const [isPremiumUser, setIsPremiumUser] = useState(false);
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [displaySubscriptionRequestPopup, setDisplaySubscriptionRequestPopup] =
    useState(false);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [expandSearch, setExpandSearch] = useState(false);

  const [currentPastPage, setCurrentPastPage] = useState(1);
  const [paginatedPastEvents, setPaginatedPastEvents] = useState([]);

  const callSchedulefromParent = () => {
    setPopupVisible(!popupVisible);
  };

  useEffect(() => {
    tableOrUserList();
    // getEventData();
  }, []);

  useEffect(() => {
    if (mobileScreen) {
      setExpandSearch(true);
    }
  }, [mobileScreen]);

  const handleJoinTableConfirmation = (data, event) => {
    console.log(event.target.alt);
    console.log(data);
    if (event.target.alt.indexOf("Table") === -1) return;
    if (data?.room_limit === data?.user_count) {
      toast.error("Room limit reached");
    } else {
      const userList = data?.user_list;
      const userFound =
        userList?.length && userList?.find((u) => u.id === userId);

      if (userFound) {
        toast.error("You already joined the table");
        return;
      }

      setPopupJoinTableNumber(data?.room_slug);
      joinTableConfirmationRef.current.click();
    }
  };

  const handleCloseTableConfirmation = () => {
    joinTableConfirmationClosebtnRef.current.click();
  };

  const handleJoinTable = () => {
    meetingTableRef.current.updateUserCreditDetails(popupJoinTableNumber);
  };

  function distributeUsersIntoGroups(users, roomLimit) {
    const numberOfGroups = 4;
    let distribution = [];

    if (roomLimit === 4) {
      distribution = [1, 1, 1, 1]; // Each group gets 1 user
    } else if (roomLimit === 6) {
      distribution = [2, 1, 2, 1]; // Groups 1 and 3 get 2 users, others get 1
    } else if (roomLimit === 8) {
      distribution = [3, 1, 3, 1]; // Groups 1 and 3 get 3 users, others get 1
    } else {
      const baseUsersPerGroup = Math.floor(roomLimit / numberOfGroups);
      const remainder = roomLimit % numberOfGroups;

      distribution = Array(numberOfGroups).fill(baseUsersPerGroup);

      for (let i = 0; i < remainder; i++) {
        distribution[i % 2 === 0 ? 0 : 2]++;
      }
    }

    const groups = [];
    let userIndex = 0;

    for (let groupIndex = 0; groupIndex < numberOfGroups; groupIndex++) {
      const userCount = distribution[groupIndex];
      const groupUsers = [];

      for (let i = 0; i < userCount && userIndex < users.length; i++) {
        groupUsers.push(users[userIndex]);
        userIndex++;
      }

      groups.push(groupUsers);
    }

    return groups;
  }

  const tableOrUserList = async (roomID) => {
    const configheader = {
      "Content-Type": `application/json`,
    };
    try {
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/rooms-users`,
        { headers: configheader },
      );

      const eventTableUsers = [];
      const otherTableUsers = [];
      response?.data?.forEach((table) => {
        const users = table?.users || [];
        if (table?.room_slug === "event_table") {
          eventTableUsers.push({
            id: table?.id,
            room_title: table?.room_title,
            room_slug: table?.room_slug,
            room_limit: table?.room_limit,
            user_count: users?.length || 0,
            user_list: users || [],
            users: distributeUsersIntoGroups(users, table?.room_limit) || [],
          });
        } else {
          otherTableUsers.push({
            id: table?.id,
            room_title: table?.room_title,
            room_slug: table?.room_slug,
            room_limit: table?.room_limit,
            user_count: users?.length || 0,
            user_list: users || [],
            users: distributeUsersIntoGroups(users, table?.room_limit) || [],
          });
        }
      });
      setTableList(otherTableUsers);
      setEventTableUsers(eventTableUsers);

      console.log({ eventTableUsers });

      // const tables = response?.data?.map((table) => {
      //   const users = table?.users || [];

      //   return {
      //     id: table?.id,
      //     room_title: table?.room_title,
      //     room_slug: table?.room_slug,
      //     room_limit: table?.room_limit,
      //     user_count: users?.length || 0,
      //     user_list: users || [],
      //     users: distributeUsersIntoGroups(users, table?.room_limit) || [],
      //   };
      // });
      // setTableList(tables);
      setLoadingTableList(false);
      // return tables;
      return otherTableUsers;
    } catch (e) {
      toast.error(
        e?.response?.data?.message ||
          "Something went wrong. Please try again later.",
      );
      setLoadingTableList(false);
      return [];
    }
  };

  const handleAdd20CreditBeta = async () => {
    if (parseInt(userCredit) > 100) {
      toast.warning("Max credits reached for current plan.");
      return;
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Barer ${token}`,
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/add-beta-credits`,
        {
          credit: 20,
          user_id: userId,
        },
        {
          headers,
        },
      );

      if (response.status === 200) {
        dispatch(updateBetaCredit(20));
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const logo = (
    <span
      className="cursor-pointer"
      style={{ fontWeight: 900, color: "#3761b3", fontStyle: "italic" }}
      onClick={() => handleProfileRedirect("", userId)}
    >
      3For3 Networking
    </span>
  );

  const handleOpenCreateEventSubscriptionRequest = () => {
    console.log("Open subscription request");
    setDisplaySubscriptionRequestPopup(true);
  };

  const handleOpenCreateEvent = () => {
    setOpenCreateEvent(true);
  };

  const handleCloseCreateEvent = () => {
    setOpenCreateEvent(false);
    setReadOnlyData(false);
    setEventData(initialEventData);
  };

  const getActiveSubscription = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/get-current-subscription.php",
        {
          userId: userId,
        },
        { headers: headers },
      );
      console.log(response.data);

      if (response.data) {
        const subscription = response.data;
        const activeSubscriptionPlan = subscription.active_plan;
        setCurrentSubscription(activeSubscriptionPlan);
        console.log("Active Subscription Plan: ", activeSubscriptionPlan);
        setIsPremiumUser(activeSubscriptionPlan === "premium_plus");
      }

      return response?.data?.active_plan;
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitCreateEvent = async (e) => {
    e.preventDefault();
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Barer ${token}`,
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/submit-personal-events`,
        {
          topic_name: eventData.event_name,
          topic_description: eventData.topic_description,
          user_id: userId,
          event_date: eventData.event_date,
          event_time: eventData.event_time,
          event_type: eventData.event_type,
          event_invites: eventData.event_invites,
          httpURL: window.location.origin,
        },
        {
          headers,
        },
      );
      console.log("Event submission response: ", response);

      if (
        response.status === 200 &&
        response?.data?.event?.status === "success"
      ) {
        const event = {
          id: parseInt(response?.data?.event?.id),
          event_date: eventData.event_date,
          event_time: eventData.event_time,
          user_id: userId,
          user_name: firstName,
          user_profile:
            profile_picture ||
            `https://avatar.iran.liara.run/username?username=${firstName}`,
          action_type: "yes",
          event_type: "personal",
        };
        await callRSVP_API(event);
      }
      // Reset form and close modal
      setEventData(initialEventData);
      setOpenCreateEvent(false);
      getEventData(currentSubscription);
    } catch (error) {
      console.log(error);
    }
    console.log("Event Data Submitted: ", eventData);
  };

  const callRSVP_API = async (event) => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      let eventInvites = event.event_invites || [];

      if (event.isRegistered && eventInvites.length) {
        eventInvites = eventInvites
          .split(",")
          .filter((invite) => invite.trim() !== userEmail)
          .join(",");
      } else if (!event.isRegistered) {
        eventInvites = eventInvites.length
          ? [...eventInvites?.split(","), userEmail]
              .map((invite) => invite.trim())
              .join(",")
          : userEmail;
      }

      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/rsvp`,
        {
          event_id: event.id,
          event_date: `${event.event_date} ${event.event_time}`,
          user_id: userId,
          user_name: firstName,
          user_profile:
            profile_picture ||
            `https://avatar.iran.liara.run/username?username=${firstName}`,
          action_type: event.isRegistered ? "no" : "yes",
          event_type: "personal",
          // if user isRegistered is true then remove email from list else add to list
          event_invites: eventInvites,
        },
        { headers: headers },
      );

      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const handleRegisterForEvent = async (event) => {
    const response = await callRSVP_API(event);

    if (response.status === 200) {
      const personalevent = [...personalEvents];
      const updatedEvents = personalevent.map((e) => {
        if (e.id === event.id) {
          return { ...e, isRegistered: e.isRegistered ? false : true };
        }
        return e;
      });
      setPersonalEvents(updatedEvents);
    }
  };

  const handleRedirectToSubscriptionWindow = () => {
    // redirect using react router to /billing
    history.push("/billing");
  };
  const getEventData = async (subscription) => {
    try {
      const category = subscription?.includes("free") ? "free" : "paid";
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/get-personal-events/${category}`,
        {
          headers,
        },
      );
      const events =
        response?.data?.map((event) => ({
          ...event,
          isRegistered: event?.event_invites?.includes(userEmail),
        })) || [];

      // Filter events based on America/New_York timezone
      const { pastEvents: pastEventsFiltered, upcomingEvents } = filterEventsByTimezone(
        events,
        "America/New_York"
      );

      setPastEvents(pastEventsFiltered);
      setPersonalEvents(upcomingEvents);

      console.log("Events data: ", {
        pastEvents: pastEventsFiltered,
        upcomingEvents,
        totalEvents: events.length,
      });
    } catch (error) {
      console.log("Error fetching events:", error);
    }
  };

  const handleViewEventDetails = (event) => {
    setReadOnlyData(true);
    setOpenCreateEvent(true);
    setEventData({
      event_name: event?.topic_name || "",
      topic_description: event?.topic_description || "",
      event_date: event?.event_date || "",
      event_time: event?.event_time || "",
      event_type: event?.event_type || "public",
      event_invites: event?.event_invites || "",
    });
  };

  const handleSearchEvents = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    if (!searchTerm) {
      getEventData(currentSubscription);
      return;
    }

    const allEvents = [...pastEvents, ...personalEvents];

    setFilteredEvents(
      allEvents.filter(
        (event) =>
          event?.topic_name?.toLowerCase()?.includes(searchTerm) ||
          event?.topic_description?.toLowerCase()?.includes(searchTerm) ||
          event?.first_name?.toLowerCase()?.includes(searchTerm) ||
          event?.last_name?.toLowerCase()?.includes(searchTerm),
      ),
    );
  };

  const handleProfileRedirect = (profile_key, user_id) => {
    if (profile_key) {
      history.push(
        parseInt(user_id) === parseInt(userId)
          ? "/my-profile"
          : `/p/${profile_key}`,
      );
    } else {
      history.push("/dashboard");
    }
  };

  const handleSearchExpand = () => {
    setExpandSearch(!expandSearch);
  };

  useEffect(() => {
    // convert this to async function and await
    (async () => {
      const subscription = await getActiveSubscription();
      console.log("Subscription in useEffect: ", subscription);
      await getEventData(subscription);
    })();
  }, []);

  useEffect(() => {
    const events = filteredEvents || [];

    // pastEvent in a desc order based on event_date
    // Feb 27 11:30 AM
    // this time is not passed in EST timezone but still got records in past events
    // setPastEvents(
    //   events
    //     .filter((event) => {
    //       // new Date() with EST timezone
    //       const estTimezone = "America/New_York";
    //       const now = moment().tz(estTimezone);
    //       console.log(now, "Current time in EST: ");
    //       const eventDate = moment(
    //         event.event_date + " " + event.event_time,
    //         "YYYY-MM-DD HH:mm:ss",
    //       ).tz(estTimezone);
    //       return eventDate.isBefore(now);
    //     })
    //     .sort((a, b) => new Date(b.event_date) - new Date(a.event_date)),
    // );
    // setPersonalEvents(
    //   events.filter((event) => {
    //     // new Date() with EST timezone
    //     const estTimezone = "America/New_York";
    //     const now = moment().tz(estTimezone);
    //     const eventDate = moment(
    //       event.event_date + " " + event.event_time,
    //       "YYYY-MM-DD HH:mm:ss",
    //     ).tz(estTimezone);
    //     return eventDate.isSameOrAfter(now);
    //   }),
    // );
    // Filter events based on America/New_York timezone
    const { pastEvents: pastEventsFiltered, upcomingEvents } =
      filterEventsByTimezone(events, "America/New_York");

    setPastEvents(pastEventsFiltered);
    setPersonalEvents(upcomingEvents);

    console.log("Filtered Events: ", pastEventsFiltered, upcomingEvents);
  }, [filteredEvents]);

  const handlePaginatedData = (data, currentPage) => {
    const paginatedEvents = data.slice(
      (currentPage - 1) * 10,
      currentPage * 10,
    );
    return paginatedEvents;
  };

  useEffect(() => {
    const paginatedEvents = handlePaginatedData(pastEvents, currentPastPage);
    setPaginatedPastEvents(paginatedEvents);
  }, [currentPastPage, pastEvents]);

  useEffect(() => {
    const paginatedEvents = handlePaginatedData(
      personalEvents,
      currentPersonalPage,
    );
    console.log("Paginated Personal Events: ", paginatedEvents.length);
    setPaginatedPersonalEvents(paginatedEvents);
  }, [currentPersonalPage, personalEvents]);

  const handleScrollToTop = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const CreateEventButton = isPremiumUser ? (
    <button
      className="btn btn-primary"
      disabled={false}
      onClick={handleOpenCreateEvent}
    >
      Create Event
    </button>
  ) : (
    <button
      className="btn btn-primary"
      disabled={false}
      onClick={handleOpenCreateEventSubscriptionRequest}
    >
      Create Event
    </button>
  );

  const PaginationContainer = (
    data,
    currentPage,
    setCurrentPage,
    sectionId,
  ) => {
    return (
      data?.length > 10 && (
        <div className="pagination-container d-flex justify-content-center mt-3">
          <ul className="pagination">
            {Array.from({ length: Math.ceil(data.length / 10) }, (_, i) => (
              <li
                key={i}
                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => {
                    handleScrollToTop(sectionId);
                    setCurrentPage(i + 1);
                  }}
                >
                  {i + 1}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )
    );
  };

  return (
    <MainContainer
      callSchedulefromParent={callSchedulefromParent}
      popupVisible={popupVisible}
    >
      <div className="row py-4 px-3">
        <div className="col-12 col-md-4 d-flex align-items-center justify-content-between pb-3 pb-md-0">
          <h1 className="title mb-0">Events</h1>

          <div className="align-items-center d-flex d-sm-none">
            {CreateEventButton}
          </div>
        </div>
        <div className="col-12 col-md-8 text-md-right">
          <div className="row">
            <div className="col-12 mb-2 mb-md-0">
              <div className="d-flex align-item-center justify-content-end">
                <div
                  class={`searchbox mr-0 mr-sm-2 ${mobileScreen ? "mobile-view" : ""}`}
                >
                  <input
                    type="search"
                    name="searchEvents"
                    placeholder="Search events..."
                    className={expandSearch ? "active" : ""}
                    onChange={(e) => {
                      // if no value then reset the filter
                      handleSearchEvents(e);
                    }}
                  />

                  <div class="searchbtn" onClick={handleSearchExpand}>
                    <IoSearchSharp size={22} />
                  </div>
                </div>
                <div className="align-items-center d-none d-sm-flex">
                  {CreateEventButton}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12">
          {/* Upcoming / Live Events */}
          <div className="p-3 border mt-4" id="live-events-section">
            <p className="font-weight-bold mb-3">Live / Upcoming</p>

            <div className="custom-table-event-list">
              <div className="head-row row">
                <div className="col-12 col-md-1 col-lg-3 font-weight-bold">
                  Event By
                </div>
                <div className="col-12 col-md-5 font-weight-bold">Event</div>
                <div className="col-12 col-md-2 font-weight-bold">
                  Time (EST)
                </div>
                <div className="col-12 col-md-2"></div>
              </div>

              {paginatedPersonalEvents.length > 0 ? (
                paginatedPersonalEvents.map((event, index) => (
                  <div className="body-row row" key={index}>
                    <div className="col-12 col-md-1 col-lg-3 text-left order-1">
                      {event.first_name ? (
                        <div
                          className="text-left cursor-pointer"
                          onClick={() =>
                            handleProfileRedirect(
                              event?.profile_unique_key,
                              event?.user_id,
                            )
                          }
                        >
                          <img
                            src={event.profile_picture_url}
                            alt={event.first_name}
                            className="rounded-circle border border-dark bg-secondary mr-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />{" "}
                          <small className="text-capitalize">
                            {event.first_name} {event.last_name}
                          </small>
                        </div>
                      ) : (
                        logo
                      )}
                    </div>
                    <div className="col-12 col-md-5 order-3 order-md-2 mt-3 mt-sm-0">
                      <p className="mb-0">
                        <b
                          className="cursor-pointer btn btn-link p-0"
                          onClick={() => handleViewEventDetails(event)}
                        >
                          {event?.topic_name}
                        </b>
                      </p>
                      <p className="mb-0">{event?.topic_description}</p>
                    </div>
                    <div
                      className={`col-12 col-md-2 order-2 order-md-3 py-1 py-sm-0  ${mobileScreen ? "border-top border-bottom" : ""}`}
                    >
                      <div className="row">
                        <div className="col-6 col-md-12">
                          <p className="mb-0 align-items-center d-flex justify-content-sm-center justify-content-start">
                            <CiCalendar
                              className="mr-2 d-inline-block d-sm-none"
                              size={20}
                            />
                            {new Date(
                              `${event?.event_date}T${event?.event_time}`,
                            ).toLocaleDateString("en-US", {
                              month: "short",
                              day: "2-digit",
                            })}
                          </p>
                        </div>
                        <div className="col-6 col-md-12">
                          <p className="mb-0 align-items-center d-flex justify-content-sm-center justify-content-start">
                            <CiClock2
                              className="mr-2 d-inline-block d-sm-none"
                              size={20}
                            />
                            {new Date(
                              `${event?.event_date}T${event?.event_time}`,
                            ).toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-2 order-4 mt-3 mt-sm-0 d-flex justify-content-center">
                      {/* <button
                        className="btn font-weight-bold p-sm-0 btn-link"
                        onClick={() => handleViewEventDetails(event)}
                        style={{ fontSize: 14 }}
                      >
                        View Details
                      </button> */}

                      {/* I would like to disabled false for the Join button if event date + time is before 5 minutes */}                      

                      <CustomTooltip title="Room will be available 5 minutes before event time.">
                        <button
                          className="btn font-weight-bold p-sm-0 btn-link"
                          style={{ fontSize: 14 }}
                          disabled={
                            !isEventJoinable(event, 5, "America/New_York")
                          }
                        >
                          Join
                        </button>
                      </CustomTooltip>

                      {parseInt(event?.user_id) !== userId &&
                        event.event_date &&
                        new Date(event.event_date) > new Date() && (
                          <button
                            className="btn font-weight-bold p-sm-0 btn-link"
                            onClick={() => handleRegisterForEvent(event)}
                            style={{ fontSize: 14, marginLeft: 10 }}
                          >
                            {event.isRegistered ? "Unregister" : "Register"}
                          </button>
                        )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="body-row row">
                  <div className="col-12 col-md-11 text-center">
                    No events submitted yet.
                  </div>
                </div>
              )}

              {/* want pagination so that at a time 10 records needs to be displayed */}
              {PaginationContainer(
                personalEvents,
                currentPersonalPage,
                setCurrentPersonalPage,
                "live-events-section",
              )}
            </div>
          </div>

          {/* Past Events */}
          <div className="p-3 border mt-5" id="past-events-section">
            <p className="font-weight-bold mb-3">Past</p>

            <div className="custom-table-event-list">
              <div className="head-row row">
                <div className="col-12 col-md-1 col-lg-3 font-weight-bold">
                  Event By
                </div>
                <div className="col-12 col-md-5 font-weight-bold">Event</div>
                <div className="col-12 col-md-2 font-weight-bold">
                  Time (EST)
                </div>
                <div className="col-12 col-md-2"></div>
              </div>

              {/* now filter data based on current page */}
              {paginatedPastEvents.length > 0 ? (
                paginatedPastEvents.map((event, index) => (
                  <div className="body-row row" key={index}>
                    <div className="col-12 col-md-1 col-lg-3 text-left order-1">
                      {event.first_name ? (
                        <div
                          className="text-left cursor-pointer"
                          onClick={() =>
                            handleProfileRedirect(
                              event?.profile_unique_key,
                              event?.user_id,
                            )
                          }
                        >
                          <img
                            src={event.profile_picture_url}
                            alt={event.first_name}
                            className="rounded-circle border border-dark bg-secondary mr-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />{" "}
                          <small className="text-capitalize">
                            {event.first_name} {event.last_name}
                          </small>
                        </div>
                      ) : (
                        logo
                      )}
                    </div>
                    <div className="col-12 col-md-5 order-3 order-md-2 mt-3 mt-sm-0">
                      <p className="mb-0">
                        <b
                          className="cursor-pointer btn btn-link p-0"
                          onClick={() => handleViewEventDetails(event)}
                        >
                          {event?.topic_name}
                        </b>
                      </p>
                      <p className="mb-0">{event?.topic_description}</p>
                    </div>
                    <div
                      className={`col-12 col-md-2 order-2 order-md-3 py-1 py-sm-0  ${mobileScreen ? "border-top border-bottom" : ""}`}
                    >
                      <div className="row justify-content-center">
                        <div className="col-6 col-md-12">
                          <p className="mb-0 align-items-center d-flex justify-content-sm-center justify-content-start">
                            <CiCalendar
                              className="mr-2 d-inline-block d-sm-none"
                              size={20}
                            />
                            {new Date(
                              `${event?.event_date}T${event?.event_time}`,
                            ).toLocaleDateString("en-US", {
                              month: "short",
                              day: "2-digit",
                            })}
                          </p>
                        </div>
                        <div className="col-6 col-md-12">
                          <p className="mb-0 align-items-center d-flex justify-content-sm-center justify-content-start">
                            <CiClock2
                              className="mr-2 d-inline-block d-sm-none"
                              size={20}
                            />
                            {new Date(
                              `${event?.event_date}T${event?.event_time}`,
                            ).toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-2 order-4 mt-3 mt-sm-0">
                      <button
                        className="btn font-weight-bold p-sm-0 btn-link"
                        onClick={() => handleViewEventDetails(event)}
                        style={{ fontSize: 14 }}
                      >
                        View Details
                      </button>

                      {parseInt(event?.user_id) !== userId &&
                        event.event_date &&
                        new Date(event.event_date) > new Date() && (
                          <button
                            className="btn font-weight-bold p-sm-0 btn-link"
                            onClick={() => handleRegisterForEvent(event)}
                            style={{ fontSize: 14, marginLeft: 10 }}
                          >
                            {event.isRegistered ? "Unregister" : "Register"}
                          </button>
                        )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="body-row row">
                  <div className="col-12 col-md-11 text-center">
                    No events submitted yet.
                  </div>
                </div>
              )}

              {/* want pagination so that at a time 10 records needs to be displayed */}
              {PaginationContainer(
                pastEvents,
                currentPastPage,
                setCurrentPastPage,
                "past-events-section",
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="text-center pb-5">
        <div className="row mb-5">
          <div className="col-12">
            <CountdownTimer />
            {currentEventDetail && <Attendees userId={userId} />}
          </div>
        </div>

        <Events />

        <div className="row mt-5">
          <div className="col-12">
            {isMasterTableEnable ? (
              <div className="mb-4">
                <h2 className="title">The Table</h2>

                <button
                  type="button"
                  className="btn btn-primary rounded-10 mt-2 px-5"
                  onClick={() =>
                    meetingTableRef.current.handleJoinTable("event_table")
                  }
                >
                  Join the Table
                </button>

                <div className="table-users-list mt-2">
                  {eventTableUsers[0]?.user_list?.length > 0 && (
                    <div className="d-flex align-items-center flex-column align-content-center w-100 mb-3">
                      <div className="d-flex">
                        {eventTableUsers[0]?.user_list.map(
                          (person, index) =>
                            index < 5 && (
                              <img
                                key={index}
                                src={person.avatar}
                                alt={person.name}
                                className="rounded-circle border border-dark bg-secondary"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                  marginLeft: index === 0 ? "0" : "-20px",
                                  zIndex: 10 + index,
                                }}
                              />
                            ),
                        )}
                        {eventTableUsers[0]?.user_list.length > 5 ? (
                          <div
                            className="rounded-circle text-white d-flex justify-content-center align-items-center border border-dark"
                            style={{
                              width: "50px",
                              height: "50px",
                              marginLeft: "-20px",
                              fontSize: "18px",
                              zIndex: 15,
                              background: "#3762b4",
                            }}
                          >
                            {eventTableUsers[0]?.user_list.length - 5}+
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <h2 className="title">Join the Table</h2>
            )}
            {!email_verified ? (
              <div className="welcome-subtitle mb-0 text-danger">
                Verify your email to join.
              </div>
            ) : (
              <>
                <div className="welcome-subtitle mb-0">
                  <strong>10 credits</strong> to join.
                </div>
                <p className="mt-1 mb-0">
                  <span
                    className="btn p-0 btn-link"
                    onClick={handleAdd20CreditBeta}
                  >
                    Welcome to the beta. Get 20 free credits.
                  </span>
                </p>
              </>
            )}
          </div>

          {isLoadingTableList ? (
            <div className="col-12 text-center">Loading...</div>
          ) : (
            <>
              {!isLoadingTableList && (
                <Pusher
                  channel="meeting"
                  event="meeting_updates"
                  onUpdate={tableOrUserList}
                />
              )}

              {tableList.map((table, tableIndex) => (
                <MeetingTable
                  key={tableIndex}
                  tableIndex={tableIndex}
                  data={table}
                  isLoading={isLoadingTableList}
                  ref={meetingTableRef}
                  handleJoinTableConfirmation={handleJoinTableConfirmation}
                  handleCloseTableConfirmation={handleCloseTableConfirmation}
                  tableDisable={isAllTableDisable}
                />
              ))}
            </>
          )}
        </div>

        <div className="row mt-5" id="app_download_sec">
          <div className="col-12 col-lg-6 mx-auto">
            <p>
              <SiJitsi fontSize={"3em"} />
            </p>
            <p className="font-weight-bold" id="info">
              We use Jitsi for the ultimate web chat experience. Download the
              app.
            </p>

            <div className="row justify-content-center" id="logos">
              <div className="col-12 col-sm-6 col-md-4 col-lg-6 my-2 text-lg-right">
                <a
                  href="https://apps.apple.com/us/app/jitsi-meet/id1165103905"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={AppleStore}
                    alt="Apple store"
                    className="img-fluid"
                  />
                </a>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-6 my-2 text-lg-left">
                <a
                  href="https://play.google.com/store/apps/details?id=org.jitsi.meet&pli=1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={GooglePlayStore}
                    alt="Google play store"
                    className="img-fluid"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="jointablemodal"
          tabIndex="-1"
          aria-labelledby="jointablemodalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="jointablemodalLabel">
                  Join the Table
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  ref={joinTableConfirmationClosebtnRef}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <button
                  hidden={true}
                  ref={joinTableConfirmationRef}
                  data-toggle="modal"
                  data-target="#jointablemodal"
                ></button>
              </div>
              <div className="modal-body">
                <p className="m-0 text-left">
                  Confirm to join the table. <strong>10 credits</strong> to
                  join.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary rounded-10"
                  onClick={handleJoinTable}
                >
                  Confirm
                </button>
                <button
                  id="jointableClosebtn"
                  type="button"
                  className="btn btn-secondary rounded-10"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <Modal isOpen={openCreateEvent} size={"modal-lg"}>
        <ModalHeader>
          <h5>{readOnlyData ? "View Event" : "Create Event"}</h5>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={handleCloseCreateEvent}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <form
          onSubmit={!readOnlyData ? handleSubmitCreateEvent : null}
          validate={true}
        >
          <ModalBody>
            <div className="row align-items-center">
              <div className="col-12 col-md-3">Event Name *</div>
              <div className="col-12 col-md-9">
                <input
                  type="text"
                  maxLength={50}
                  name="topic_name"
                  className="form-control"
                  placeholder="Enter event name"
                  required={true}
                  readOnly={readOnlyData}
                  value={eventData.event_name}
                  onChange={(e) =>
                    setEventData({ ...eventData, event_name: e.target.value })
                  }
                />
                <small className="text-muted">
                  {eventData?.event_name?.length}/50 characters
                </small>
              </div>
            </div>
            <div className="row mt-3 align-items-center">
              <div className="col-12 col-md-3">Topic Description *</div>
              <div className="col-12 col-md-9">
                <input
                  type="text"
                  maxLength={150}
                  name="topic_description"
                  className="form-control"
                  placeholder="Enter topic description"
                  required={true}
                  readOnly={readOnlyData}
                  value={eventData.topic_description}
                  onChange={(e) =>
                    setEventData({
                      ...eventData,
                      topic_description: e.target.value,
                    })
                  }
                />
                <small className="text-muted">
                  {eventData?.topic_description?.length}/150 characters
                </small>
              </div>
            </div>
            <div className="row mt-3 align-items-center">
              <div className="col-12 col-md-3">Date / Time *</div>
              <div className="col-12 col-md-9">
                <div className="row">
                  <div className="col-6">
                    <input
                      type="date"
                      name="event_date"
                      className="form-control"
                      placeholder="Enter event date"
                      required={true}
                      readOnly={readOnlyData}
                      value={eventData.event_date}
                      onChange={(e) =>
                        setEventData({
                          ...eventData,
                          event_date: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-6">
                    <input
                      type="time"
                      name="event_time"
                      className="form-control"
                      placeholder="Enter event time"
                      required={true}
                      readOnly={readOnlyData}
                      value={eventData.event_time}
                      onChange={(e) =>
                        setEventData({
                          ...eventData,
                          event_time: e.target.value,
                        })
                      }
                    />
                    <span className="text-muted small">Event time in EST</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3 align-items-center">
              <div className="col-12 col-md-3">Event Type *</div>
              <div className="col-12 col-md-9">
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="eventType"
                    id="publicEvent"
                    value="public"
                    readOnly={readOnlyData}
                    checked={eventData.event_type === "public"}
                    onChange={(e) =>
                      setEventData({
                        ...eventData,
                        event_type: e.target.value,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="publicEvent">
                    Public
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="eventType"
                    id="privateEvent"
                    value="private"
                    readOnly={readOnlyData}
                    disabled={true}
                    checked={eventData.event_type === "private"}
                    onChange={(e) =>
                      setEventData({
                        ...eventData,
                        event_type: e.target.value,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="privateEvent">
                    Private (Coming Soon)
                  </label>
                </div>
              </div>
            </div>
            {/* <div className="row mt-3 align-items-center">
              <div className="col-12 col-md-3">Invite</div>
              <div className="col-12 col-md-9">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Invite by email (comma separated)"
                  required={false}
                  readOnly={readOnlyData}
                  disabled={true}
                  value={eventData.event_invites}
                  onChange={(e) =>
                    setEventData({
                      ...eventData,
                      event_invites: e.target.value,
                    })
                  }
                />
              </div>
            </div> */}
          </ModalBody>
          <ModalFooter>
            {!readOnlyData && (
              <button
                type="submit"
                className="btn btn-primary rounded-10 px-4"
                disabled={
                  !(
                    eventData.event_name &&
                    eventData.topic_description &&
                    eventData.event_date &&
                    eventData.event_time
                  )
                }
              >
                Submit
              </button>
            )}
            <button
              id="meetingcomplete_close_btn"
              type="button"
              className="btn btn-outline-secondary rounded-10 px-4"
              onClick={handleCloseCreateEvent}
            >
              Cancel
            </button>
          </ModalFooter>
        </form>
      </Modal>
      {/* displaySubscriptionRequestPopup */}

      <Modal isOpen={displaySubscriptionRequestPopup}>
        <ModalHeader>
          <h5>Upgrade to Premium Plus</h5>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={() => setDisplaySubscriptionRequestPopup(false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>

        <ModalBody>
          <div className="row align-items-center">
            <div className="col-12">
              <p>
                Creating events is a premium feature. Upgrade to Premium Plus to
                create and host your own events.
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-primary rounded-10 px-4"
            onClick={handleRedirectToSubscriptionWindow}
          >
            Upgrade
          </button>

          <button
            id="meetingcomplete_close_btn"
            type="button"
            className="btn btn-outline-secondary rounded-10 px-4"
            onClick={() => setDisplaySubscriptionRequestPopup(false)}
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    </MainContainer>
  );
}

export default EventListing;
